import { styled } from '@mui/system';
import { Box, Paper } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';
import { SectionHeading, SectionSubtext } from '../../styles';
export const SectionContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '1100px',
  margin: '0 auto',
}));

export const ContentPaper = styled(Paper)(({ theme }) => ({
  bgcolor: '#FFF',
  borderRadius: '40px',
  padding: '10px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
}));

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: theme.spacing(6),
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    gap: theme.spacing(4),
  },
}));

export const ImageBox = styled(Box)({});

export const ImageBackground = styled(Box)(({ theme }) => ({
  background: colors.iconBackground,
  borderRadius: '30px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  position: 'relative',
  width: '500px',
  height: '551px',
  [theme.breakpoints.down('md')]: {
    width: 'auto',
    height: 'auto',
  },
}));

// The circle clip and 1/1 ratio were built for the round emblem this replaced;
// the Nirva lockup is wide and would lose its wordmark to the crop.
export const PortalImage = styled(Box)(({ theme }) => ({
  width: '80%',
  height: 'auto',
  objectFit: 'contain',
  display: 'block',
  [theme.breakpoints.down('md')]: {
    width: '50%',
    padding: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '70%',
  },
}));

export const ContentBox = styled(Box)({});

export const ContentInner = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  gap: '22px',
  paddingLeft: 0,
  paddingRight: 0,

  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    gap: theme.spacing(2.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  [theme.breakpoints.between('sm', 'md')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const PortalTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: '60px',
  fontFamily: fontFamilies.gotham,
  fontWeight: 400,
  lineHeight: '77px',
  letterSpacing: '-.4px',
  textAlign: 'left',
  [theme.breakpoints.down('1000')]: {
    fontSize: '45px',
  },
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '26px',
  },
}));

export const PortalSubtitle = styled(SectionSubtext)(({ theme }) => ({
  ...theme.typography.heading,
  fontFamily: fontFamilies.gotham,
  fontWeight: 500,
  textAlign: 'left',
  fontSize: '24px !important',
  lineHeight: '100%',
  textTransform: 'uppercase',
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('1000')]: {
    fontSize: '18px !important',
  },
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    fontSize: '18px !important',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px !important',
  },
}));

export const PortalDescription = styled(SectionSubtext)(({ theme }) => ({
  ...theme.typography.heading,
  fontFamily: fontFamilies.quicksand,
  fontSize: '24px',
  display: 'inline',
  whiteSpace: 'pre-line',
  lineHeight: '37px',
  letterSpacing: '.8px',

  '& b': {
    fontWeight: 500,
  },

  [theme.breakpoints.down('1000')]: {
    fontSize: '18px !important',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

export const PortalDescriptionBold = styled(PortalDescription)(({ theme }) => ({
  fontWeight: 500,
  display: 'inline',
  [theme.breakpoints.down('1000')]: {
    fontSize: '18px !important',
  },
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'center',
  width: 'fit-content',
  margin: '50px auto',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));
